module.exports = __webpack_public_path__ + "img/q2-opt-c.99d95894.png";